var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21353E",
    d: "M18 9.591a.661.661 0 1 0-.557-1.2l-4.517-2.606a.66.66 0 1 0-1.32 0L7.05 8.361a.66.66 0 0 0-.621 1.157v5.195l-.874-.493l.167-.317H4.286l.78 1.238l.172-.334l7.041 4.05l5.096-2.957a.65.65 0 0 0 .398.141a.66.66 0 0 0 .232-1.286v-5.16zM7.068 15.094V9.57l.077-.043L12 12.343V17.9zm5.185-3.343L7.45 8.94v-.047l4.474-2.525a.66.66 0 0 0 .69 0l4.457 2.546l-4.812 2.842zm.656.386l4.449-2.649v5.28zm-.266.591l4.427 2.615l-4.427 2.558z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.86e25f0f7af89601c1caf3cbfc2ea17c.svg";
export { ForwardRef as ReactComponent };